/**
 * Utility formattazione date per mAIstro.
 * Input: stringa ISO "YYYY-MM-DD" o datetime ISO.
 * NON usare per input type=date (quelli vogliono YYYY-MM-DD).
 */

export const formatDate = (dateStr) => {
  if (!dateStr) return '—';
  const d = dateStr.slice(0, 10); // prendi solo YYYY-MM-DD se datetime
  const [y, m, day] = d.split('-');
  return day && m && y ? `${day}/${m}/${y}` : '—';
};

const MESI_SHORT = ['gen','feb','mar','apr','mag','giu','lug','ago','set','ott','nov','dic'];

export const formatDateShort = (dateStr) => {
  if (!dateStr) return '—';
  const d = dateStr.slice(0, 10);
  const [y, m, day] = d.split('-');
  if (!day || !m) return '—';
  return `${parseInt(day)} ${MESI_SHORT[parseInt(m) - 1]}`;
};
